
/**
 * The purpose of this is file is to share variables between
 * CSS and JS. E.g.
 * 	In css: $primaryColor
 * 	in JS:
 * 		let variables = require('./variables.js');
 * 		console.log(variables.primaryColor);
 *
 * Note that PostCSS does not allow you to read properties of
 * variables so values must be simple (string, numbers, ...)
 * and not objects.
 */
module.exports = {
	screen_xxl:			'1364px',
	screen_xl: 			'1352px',
	screen_large:		'1334px',
	screen_wrapper:		'1200px',
	screen_mobileMenu: '800px',
	screen_callToActionStack: '730px',
	screen_personPage_stack: '650px',
	screen_smallest: '320px',
	defaultSpacing_H: '20px',
	slideDeck_scrollRange_viewportPercent: .5,
	slideDeck_imageContainer_maxWidth: '1334px'
};
